import React from "react";
import {useIsPathIncludes} from "modules/utils/hooks";
import {useSelector} from "react-redux";
import {getIsHeadsWereChanged} from "modules/selectors";
import {PrimaryButton} from "components/styled";
import {useTranslation} from "react-i18next";

interface IProps {
	saveTeamHandle: () => void;
	clearTeam: () => void;
	autoFillHandler: () => void;
}

export const LockoutButtons: React.FC<IProps> = ({autoFillHandler, clearTeam, saveTeamHandle}) => {
	const isTransferPage = useIsPathIncludes("transfers");
	const isHeadsHasChanges = useSelector(getIsHeadsWereChanged);
	const {t} = useTranslation();

	if (!isHeadsHasChanges || isTransferPage) {
		return null;
	}
	return (
		<React.Fragment>
			<PrimaryButton onClick={saveTeamHandle}>{t("team.summary.save")}</PrimaryButton>
		</React.Fragment>
	);
};
